import { render, staticRenderFns } from "./Strut1500.vue?vue&type=template&id=6bca994d"
import script from "./Strut1500.vue?vue&type=script&lang=js"
export * from "./Strut1500.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports